let ipcRenderer: Electron.IpcRenderer;
const isElectron = !!window.require;
if (isElectron) {
  ipcRenderer = window.require('electron').ipcRenderer;
}

export const stopProfileOrbita = (profileId: string): void => {
  ipcRenderer && ipcRenderer.invoke('stop-profile', profileId);
};
